import React from 'react';
import Header from './components/Header.jsx';
import SideBySideCard from './components/cards/sideBySideCard.jsx';
import LeftCard from './components/cards/leftCard.jsx';
import RightCard from './components/cards/rightCard.jsx';
import DonateCard from './components/cards/donateCard.jsx';
import CreditsCard from './components/cards/creditsCard.jsx';
import Article from './components/Article.jsx';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import './App.css';


function App() {
  return (
    <div className="App">
      <Header
        rightLogo={`${process.env.PUBLIC_URL}/images/old-lantern-logo.png`}
        leftLogo={`${process.env.PUBLIC_URL}/images/tmd-logo-white.png`}
        donateUrl={'http://www.mymediamate.com/lantern-michigan-daily-rivalry'}
      />
      <SideBySideCard />
      <RightCard
        year={"THE RIVALRY ISSUE"}
        headline={"DON BROWN’S CHANCE AT GLORY"}
        authorName={"MAX MARCOVITCH"}
        authorPosition={"MANAGING SPORTS EDITOR"}
        logo={`${process.env.PUBLIC_URL}/images/tmd-logo-white.png`}
        theme={'maize'}
        isColor={true}
        id="michigan1"
        url={"/article/don-brown-glory"}
      />
      <LeftCard
        year={"THE RIVALRY ISSUE"}
        headline={"A WORLD AWAY: HOW JOSH METELLUS MADE IT FROM NORTH MIAMI TO MICHIGAN"}
        authorName={"ETHAN SEARS"}
        authorPosition={"MANAGING SPORTS EDITOR"}
        logo={`${process.env.PUBLIC_URL}/images/tmd-logo-white.png`}
        theme={'maize'}
        isColor={true}
        id="michigan2"
        url={"/article/metellus-upbringing"}
      />
      <LeftCard
        year={"THE RIVALRY ISSUE"}
        headline={"SAME GAME, NEW DAY"}
        authorName={"GRIFFIN STROM"}
        authorPosition={"SPORTS EDITOR"}
        logo={`${process.env.PUBLIC_URL}/images/old-lantern-logo.png`}
        theme={'ohio'}
        isColor={true}
        id="ohio1"
        url={"/article/ryan-day-coach"}
      />
      <DonateCard />
      <RightCard
        year={"THE RIVALRY ISSUE"}
        headline={"POACHED FROM ENEMY LINES"}
        authorName={"GRIFFIN STROM"}
        authorPosition={"SPORTS EDITOR"}
        logo={`${process.env.PUBLIC_URL}/images/old-lantern-logo.png`}
        theme={'ohio'}
        isColor={true}
        id="ohio2"
        url={"/article/mattison-washington-poached"}
      />
      <LeftCard
        year={"THE RIVALRY ISSUE"}
        headline={"HARBAUGH'S FINEST HOUR"}
        authorName={"ARIA GERSON"}
        authorPosition={"DAILY SPORTS EDITOR"}
        logo={`${process.env.PUBLIC_URL}/images/tmd-logo-black.png`}
        theme={'maize'}
        isColor={false}
        id="michigan3"
        url={"/article/harbaugh-finest-hour"}
      />
      <LeftCard
        year={"THE RIVALRY ISSUE"}
        headline={"IN TOLEDO, A COMMUNITY WATCHES ON FOR SHEA PATTERSON"}
        authorName={"THEO MACKIE"}
        authorPosition={"DAILY SPORTS EDITOR"}
        logo={`${process.env.PUBLIC_URL}/images/tmd-logo-white.png`}
        theme={'maize'}
        isColor={true}
        id="michigan4"
        url={"/article/shea-patterson"}
      />
      <RightCard
        year={"THE RIVALRY ISSUE"}
        headline={"PLAYING THE SPOILER"}
        authorName={"ANDY ANDERS"}
        authorPosition={"ASSISTANT SPORTS EDITOR"}
        logo={`${process.env.PUBLIC_URL}/images/lantern-logo-black.png`}
        theme={'ohio'}
        isColor={false}
        id="ohio3"
        url={"/article/spoiler"}
      />
      <RightCard
        year={"THE RIVALRY ISSUE"}
        headline={"TOLEDO: CAUGHT IN THE CROSSFIRE"}
        authorName={"GRIFFIN STROM"}
        authorPosition={"SPORTS EDITOR"}
        logo={`${process.env.PUBLIC_URL}/images/old-lantern-logo.png`}
        theme={'ohio'}
        isColor={true}
        id="ohio4"
        url={"/article/buckeye-wolverine"}
      />
      <CreditsCard />
    </div>
  );
}

export default App;



